<template>
	<div @wheel="wheelHandler" class="map-view map-parent">
		<map-comp v-if="store.map" @positionError="onPositionError"
			:key="store.satellite && store.map.satellite ? 't' : 'f'" />
		<p v-if="store.mapState == MapState.NotFound" class="content">No map found with id '{{ route.params.id }}'
		</p>
		<p v-else-if="store.mapState == MapState.Error" class="content">Could not load the map.</p>

		<position-error v-if="showPositionError" @close="showPositionError = false" />
	</div>
</template>

<script setup lang="ts">
import { ref, computed, watch, onMounted, onUnmounted } from "vue";
import { useRoute } from "vue-router";
import MapComp from "../components/Map.vue";
import PositionError from "../components/player/PositionError.vue";
import { MapState, useStore } from "../store/Store";

const showPositionError = ref(false);
const store = useStore();
const route = useRoute();

onMounted(() => {
	//@ts-ignore
	window.prerenderReady = true;
});

onUnmounted(() => {
	window["__map_bounds__"] = undefined;
});

const name = computed((): string => {
	return store.map ? store.map.name : "";
});

// prevent zooming with wheel since ctrl-scroll zooms the map,
// and it's annoying to zoom when you accidenatly hover another element
function wheelHandler(evt: WheelEvent) {
	if (evt.ctrlKey) {
		evt.preventDefault();
	}
}

function onPositionError() {
	showPositionError.value = true;
}

watch(
	() => route,
	(to, from) => {
		if (from && to && from.params.id == to.params.id && !from.path.includes("editor"))
			return;
		store.loadMap(to.params.id as string, to.meta.draft === true);
	},
	{ immediate: true }
);

</script>

<style lang="scss">
.map-view {
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	overflow: hidden;

	>p {
		margin-left: auto;
		margin-right: auto;
		width: fit-content;
	}
}
</style>
